/**
 * Services page images — files live under `web-client/public/images/services/`.
 */
const BASE = '/images/services';

export const SERVICE_IMAGES = {
  professionalHaircut: `${BASE}/professional-haircut.webp`,
  hairColor: `${BASE}/hair-color.webp`,
  bridalMakeup: `${BASE}/bridal-makeup.webp`,
  specialEventMakeup: `${BASE}/special-event-makeup.webp`,
  gelManicure: `${BASE}/gel-manicure.webp`,
  nailArtDesign: `${BASE}/nail-art-design.webp`,
  deepCleansingFacial: `${BASE}/deep-cleansing-facial.webp`,
  antiAgingTreatment: `${BASE}/anti-aging-treatment.webp`,
  expertHairBraiding: `${BASE}/expert-hair-braiding.webp`,
  relaxationMassage: `${BASE}/relaxation-massage.webp`,
  mobileServices: `${BASE}/mobile-services.webp`,
} as const;
